import React from 'react';

class Home extends React.Component {


  render() {
    return (
      <div>
        <h1 data-testid="title" className="headingOne">Home Page</h1>
        <p>Please click on rooms to join/create</p>
        <div className="content">
          <img src={`https://i.pinimg.com/originals/ee/34/b9/ee34b943282fc97a5fbc7437b9592b8a.gif`} alt="" />
        </div>
      </div>
    );
  }
} 

export default Home;
